<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center mb-20 mb-md-30">
                <h2 class="tit tit--lg">경매결과</h2>
            </div>

            <div class="tab-wrap">
                <v-tabs centered show-arrows center-active class="tab tab--inline tab--underline-inline">
                    <v-tab to="/auction-results" exact><span>전체</span></v-tab>
                    <v-tab to="/auction-results/A" exact-path><span>Online Auction</span></v-tab>
                    <v-tab to="/auction-results/B" exact-path><span>After Sale Online</span></v-tab>
                </v-tabs>
            </div>

            <div class="my-n14 my-md-n20">
                <v-row>
                    <v-col cols="12" sm="6" v-for="program in programs" :key="program._id">
                        <auction-results-program :program="program" />
                    </v-col>
                </v-row>
            </div>

            <div class="v-pagination-wrap">
                <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-8 mb-16" @input="search()" />
            </div>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import api from "@/api";
import AuctionResultsProgram from "@/components/client/ko/auction/auction-results-program.vue";

export default {
    components: {
        ClientPage,
        AuctionResultsProgram,
    },
    props: {
        hall: { type: String, default: undefined },
    },
    data() {
        return {
            page: +this.$route.query.page || 1,
            totalCount: 0,
            limit: 8,

            programs: [],
        };
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit) || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        hall() {
            this.page = 1;
            this.search(false);
        },
    },
    methods: {
        init() {
            this.search(false);
        },
        async search(routable = true) {
            const { page, limit, skip, hall } = this;
            if (routable) this.$router.push({ query: Object.assign({}, { page }) });

            var {
                summary: { totalCount },
                programs,
            } = await api.v1.auction.programs.gets({
                headers: { skip, limit },
                params: { hall, mode: "results" },
            });

            this.programs = programs;
            this.totalCount = totalCount;
        },
    },
};
</script>
